import { CalendarDaysIcon } from '@heroicons/react/24/outline';
export const CalendarIcon = CalendarDaysIcon;
